/** 与柱状图 X 轴、对账单 PDF 分桶一致：超期为负天数 */
export const statementBucketIndexFromOverdueDay = (overdueDay) => {
	const day = Number(overdueDay);
	if (!Number.isFinite(day)) return 0;
	if (day < -30) return 0;
	if (day >= -30 && day < -10) return 1;
	if (day >= -10 && day < 0) return 2;
	if (day >= 0 && day <= 10) return 3;
	if (day > 10 && day <= 30) return 4;
	if (day > 30 && day <= 60) return 5;
	if (day > 60 && day <= 90) return 6;
	if (day > 90 && day <= 180) return 7;
	if (day > 180 && day <= 360) return 8;
	return 9;
};

/** 与柱状图 X 轴一致，用于对账单 PDF 区间筛选等 */
/** 索引小于此项为「超期」区间，大于等于此项为「近期」区间（与文案前缀一致） */
export const CHART_BUCKETS_RECENT_START_INDEX = 3;

export const CHART_LABELS = [
	'超期30天以上',
	'超期10-30天',
	'超期1-10天',
	'近期0-10天',
	'近期10-30天',
	'近期30-60天',
	'近期60-90天',
	'近期90-180天',
	'近期180-360天',
	'360天以上',
];

/** 手机柱状图 Y 轴短标签，避免竖排/横滑 */
export const CHART_LABELS_MOBILE = [
	'超期>30天',
	'超期10-30',
	'超期1-10',
	'近期0-10',
	'近期10-30',
	'近期30-60',
	'近期60-90',
	'近期90-180',
	'近期180-360',
	'360天+',
];
